import {Component} from '@angular/core';
import {OopsComponent} from '@core-app/layout/oops/oops.component';
import {APP_CONFIG} from '../../app.config';

@Component({
    selector: 'core-maintenance',
    templateUrl: './maintenance.component.html',
    standalone: false,
})
export class MaintenanceComponent extends OopsComponent {
    override ngOnInit() {
        super.ngOnInit();
        this.titleService.setTitle('Maintenance | ' + APP_CONFIG.appName);
        this.auth.initialise().subscribe(() => {
            if (this.auth.serviceProvider.status === 'ACTIVE') {
                this.router.navigate(['/']);
            }
        });
    }
}
